export default "__VITE_ASSET__yLzZqvRc__"